import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import { createStyles, makeStyles } from "@material-ui/styles";
import React, { FC, useContext } from "react";
import { ExamSessionCandidateExamState } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";
import FormGridCell from "../../common/FormGridCell";
import ExamSelect from "../../examSession/ExamSelect";
import { SchedulerCandidateContextValue } from "../context/SchedulerCandidateContext";
import { SchedulerContextValue } from "../context/SchedulerContext";
import SchedulerCandidateSelect from "../SchedulerCandidateSelect";
import SchedulerCell, { SchedulerCellProps } from "../SchedulerCell";

const useStyles = makeStyles(() =>
  createStyles({
    infoRow: {
      marginTop: 10,
    },
  })
);

const ExpertSchedulerCell: FC<SchedulerCellProps> = (props) => {
  const classes = useStyles();
  const { selectedExamDayId, exams, examDays } = useContext(SchedulerContextValue);
  const { schedulerExamCandidates } = useContext(SchedulerCandidateContextValue);
  const selectedDay = examDays.find((examDay) => examDay.id === selectedExamDayId);
  const roomAssignment = selectedDay?.roomAssignments.find((roomAssignment) => roomAssignment.roomId === props.room.id);

  if (!roomAssignment?.isPreparationRoom) {
    return <SchedulerCell {...props} />;
  }

  if (selectedDay === undefined) {
    return null;
  }

  const { timeSlotIndex } = props;

  const selectedCandidates = schedulerExamCandidates.filter(
    (schedulerExamCandidate) =>
      schedulerExamCandidate.examDayId === selectedExamDayId &&
      schedulerExamCandidate.timeSlotIndex === timeSlotIndex &&
      schedulerExamCandidate.examState !== ExamSessionCandidateExamState.Cancelled
  );
  const selectedExamIds = selectedDay.roomAssignments.reduce<string[]>((examIds, roomAssignment) => {
    roomAssignment.examAssignments.forEach((examAssignment) => {
      if (examAssignment.timeSlotIndex === timeSlotIndex && !examIds.includes(examAssignment.examId)) {
        examIds.push(examAssignment.examId);
      }
    });
    return examIds;
  }, []);

  return (
    <TableCell>
      <Grid container>
        <FormGridCell size="wide">
          <ExamSelect readonly={true} exams={exams} selectedExamIds={selectedExamIds} isMulti={true} />
        </FormGridCell>
        {selectedExamIds.length > 0 && (
          <FormGridCell size="wide" className={classes.infoRow}>
            <SchedulerCandidateSelect selectedCandidates={selectedCandidates} />
          </FormGridCell>
        )}
      </Grid>
    </TableCell>
  );
};

export default ExpertSchedulerCell;
